module.exports = __webpack_public_path__ + "static/ZapierWH-310f66255497cc36dc33675bfc602739.png";